export const EXISTING_SCHEMA_ID = '4090001';
export const MISSING_SCHEMA = '4040001';
export const FORBIDDEN = '4030003';

